export enum ROLES {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MARKETER = 'ROLE_MODERATOR'
}

export const roleOptions = [
  {
    value: ROLES.ROLE_ADMIN,
    label: 'Администратор'
  },
  {
    value: ROLES.ROLE_MARKETER,
    label: 'Маркетолог'
  }
]
